import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CurrentOpenPeriod,
  Month,
  PeriodMode,
  UpdateOpenPeriodPayload,
} from '../models/period.model';

@Injectable({ providedIn: 'root' })
export class PeriodsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/periods`;

  list(): Observable<Month[]> {
    return this.http.get<Month[]>(this.baseUrl);
  }

  current(mode: PeriodMode): Observable<CurrentOpenPeriod> {
    const params = new HttpParams().set('mode', mode);
    return this.http.get<CurrentOpenPeriod>(`${this.baseUrl}/current`, {
      params,
    });
  }

  updateOpenPeriod(
    payload: UpdateOpenPeriodPayload
  ): Observable<CurrentOpenPeriod> {
    return this.http.patch<CurrentOpenPeriod>(
      `${this.baseUrl}/open-period`,
      payload
    );
  }

  createFiscalYear(): Observable<{ createdMonthIds: number[] }> {
    return this.http.post<{ createdMonthIds: number[] }>(
      `${this.baseUrl}/fiscal-year`,
      {}
    );
  }
}
